import { useState, useEffect } from 'react';

import { PluginListenerHandle, Capacitor } from '~capacitor-plugins/core';
import { Keyboard } from '~capacitor-plugins/keyboard';

function getOffset(el: Element | null) {
  if (!el)
    return {
      top: 0,
    };

  const rect = el.getBoundingClientRect();
  return {
    top: rect.top + window.scrollY,
  };
}

const useKeyboardFeedback = () => {
  const [keyboard, setKeyboard] = useState({ height: 0, isOpen: false });
  const form = document.querySelector('form');
  const input = document.querySelector('ion-input.has-focus');
  const { top: inputPosition } = getOffset(input);
  useEffect(() => {
    let keyboardDidShowListener: PluginListenerHandle;
    let keyboardDidHideListener: PluginListenerHandle;

    async function effect() {
      keyboardDidShowListener = await Keyboard.addListener(
        'keyboardDidShow',
        ({ keyboardHeight }) => {
          setKeyboard({ height: keyboardHeight, isOpen: true });
        }
      );
      keyboardDidHideListener = await Keyboard.addListener('keyboardDidHide', () => {
        setKeyboard(info => ({ ...info, isOpen: false }));
      });
    }
    if (Capacitor.isNativePlatform()) {
      effect();
    }

    return () => {
      if (keyboardDidShowListener) {
        keyboardDidShowListener.remove();
      }
      if (keyboardDidHideListener) {
        keyboardDidHideListener.remove();
      }
    };
  }, []);

  if (!form || !Capacitor.isNativePlatform()) {
    return;
  }

  if (keyboard.isOpen && inputPosition >= keyboard.height) {
    const shift = Math.round(Math.round(inputPosition - keyboard.height));
    form.style.setProperty('transform', `translate(0, -${shift}px)`);
    form.style.setProperty('transition', 'transform 100ms linear');
  } else {
    form.style.removeProperty('transform');
  }
};

export default useKeyboardFeedback;
